import {

  DESCRIPTOR_SKIP_KEYS,

  extractCatalogueItemsFromResponse,

  type DataDescriptor,

} from '../../canvas-catalogue.util';



export interface AttrFilterRow {

  key: string;

  description: string;

  dataSchema: string;

  isDateTime: boolean;

}



const ATTR_FILTER_SKIP_KEYS = new Set([

  ...DESCRIPTOR_SKIP_KEYS,

  'columns',

  'formatVersion',

]);



function stripSchemaPrefix(value: string): string {

  return value.replace(/^(iudx:|adex:)/i, '');

}



function readDescriptorType(value: Record<string, unknown>): string {

  const parameterType = String(value['parameterType'] ?? '').trim();

  if (parameterType) {

    return parameterType;

  }



  const type = value['type'];

  if (Array.isArray(type) && type.length > 0) {

    return String(type[0]);

  }

  if (type != null && type !== '') {

    return String(type);

  }



  return '';

}



function isGeoProperty(value: Record<string, unknown>): boolean {

  const type = readDescriptorType(value);

  return /GeoProperty/i.test(type);

}



function readDataSchema(value: Record<string, unknown>): string {

  const raw = value['dataSchema'] ?? value['schemaType'] ?? value['data_schema'] ?? '';

  return stripSchemaPrefix(String(raw).trim());

}



function isFilterableDescriptorEntry(value: unknown): value is Record<string, unknown> {

  if (value == null || typeof value !== 'object' || Array.isArray(value)) {

    return false;

  }

  return !isGeoProperty(value as Record<string, unknown>);

}



function rowIsDateTime(key: string, dataSchema: string): boolean {

  if (key === 'observationDateTime' || key === 'datetime') {

    return true;

  }

  return /datetime/i.test(dataSchema);

}



/** Map catalogue `dataDescriptor` to attribute filter rows. */

export function parseDataDescriptorToAttrFilterRows(

  descriptor: DataDescriptor | undefined,

): AttrFilterRow[] {

  if (!descriptor || typeof descriptor !== 'object') {

    return [];

  }



  const rows: AttrFilterRow[] = [];

  for (const [key, value] of Object.entries(descriptor)) {

    if (ATTR_FILTER_SKIP_KEYS.has(key) || !isFilterableDescriptorEntry(value)) {

      continue;

    }

    const dataSchema = readDataSchema(value);

    rows.push({

      key,

      description: String(value['description'] ?? '').trim(),

      dataSchema,

      isDateTime: rowIsDateTime(key, dataSchema),

    });

  }

  return rows;

}



/** Resolve a catalogue item from search API response by dataset id. */

export function findCatalogueItemById(

  response: unknown,

  datasetId: string,

): Record<string, unknown> | undefined {

  const targetId = datasetId.trim();

  if (!targetId) {

    return undefined;

  }



  return extractCatalogueItemsFromResponse(response).find((item) => {

    if (!item || typeof item !== 'object') {

      return false;

    }

    const record = item as Record<string, unknown>;

    return String(record['id'] ?? '').trim() === targetId;

  }) as Record<string, unknown> | undefined;

}



export function extractDataDescriptorFromSearchResponse(

  response: unknown,

  datasetId?: string,

): DataDescriptor | undefined {

  const items = extractCatalogueItemsFromResponse(response);

  if (items.length === 0) {

    return undefined;

  }



  let item =

    datasetId?.trim() ? findCatalogueItemById(response, datasetId) : undefined;



  if (!item && items.length === 1 && items[0] && typeof items[0] === 'object') {

    item = items[0] as Record<string, unknown>;

  }



  const descriptor = item?.['dataDescriptor'];

  if (!descriptor || typeof descriptor !== 'object' || Array.isArray(descriptor)) {

    return undefined;

  }

  return descriptor as DataDescriptor;

}


